export default __webpack_public_path__ + "static/media/Icon-metro-battery-empty.60239d8d.svg";